import Vue from 'vue'
import VueRouter from 'vue-router'
import PaymentDetail from '../views/PaymentDetail'
import PurchaseDetail from '../views/PurchaseDetail'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Detalle Compra',
    component: PurchaseDetail,
    meta: {
      title: 'Detalle Compra'
    }
  },
  {
    path: '/detalle-pedido',
    name: 'Detalle Pedido',
    component: PaymentDetail,
    meta: {
      title: 'Detalle Pago'
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
